/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { useIntl } from 'react-intl';
import { RESPONSE_SUCCESS_FIELD } from '../consts';
import Info from './Info';
import Row from './Row';
import FooterButtons from './FooterButtons';

export default function ResponseScreen({
  formName,
  onHomeButtonClick,
  data,
  requestorDatetime,
  resetState
}) {
  const { formatMessage } = useIntl();
  const requestor = data && data.requestor;
  let requestorEmail;
  if (requestor && requestor.emailAddress) {
    requestorEmail = <b>{requestor.emailAddress}</b>;
  }
  const creatorEmail = <b>{formatMessage({ id: 'general.creatorEmail' })}</b>;

  return (
    <div>
      <h1 className="form-title">
        {formatMessage({ id: `response.${formName}` })} ({formName}){' '}
      </h1>
      {!!data && (
        <div>
          <Info text={formatMessage({ id: 'general.successInfo1' })} />
          <br />
          <Typography>
            {formatMessage({ id: 'general.successInfo2' }, { requestorEmail, creatorEmail })}
          </Typography>
          {requestorDatetime != null && (
            <Row
              label={formatMessage({ id: 'response.requestorDatetime' })}
              text={requestorDatetime}
            />
          )}
          <div className="response-container">
            {RESPONSE_SUCCESS_FIELD.map((field) => {
              if (field === 'requestor') {
                return (
                  <React.Fragment key={field}>
                    <Row
                      key="requestorName"
                      label={formatMessage({ id: 'response.requestorName' })}
                      text={data[field] && data[field].displayName}
                    />
                    <Row
                      key="requestorEmail"
                      label={formatMessage({ id: 'response.requestorEmail' })}
                      text={data[field] && data[field].emailAddress}
                    />
                  </React.Fragment>
                );
              }
              if (field === 'form') {
                return (
                  <Row
                    key={field}
                    label={formatMessage({ id: 'response.form' })}
                    text={formName}
                  />
                );
              }
              if (field === 'requestorLocation') {
                return (
                  <Row
                    key={field}
                    label={formatMessage({ id: 'response.requestorLocation' })}
                    text={data[field]}
                  />
                );
              }
              if (field === 'ticketNumber') {
                return (
                  <Row
                    key={field}
                    label={formatMessage({ id: 'response.ticketNumber' })}
                    text={data[field]}
                  />
                );
              }
              if (field === 'localDateTime') {
                return (
                  <Row
                    key={field}
                    label={formatMessage({ id: 'response.localDateTime' })}
                    text={data[field]}
                  />
                );
              }
              if (field === 'serverDateTime') {
                return (
                  <Row
                    key={field}
                    label={formatMessage({ id: 'response.serverDateTime' })}
                    text={data[field] || formatMessage({ id: 'not-applicable' })}
                  />
                );
              }
              if (field === 'approvalStatus') {
                return (
                  <Row
                    key={field}
                    label={formatMessage({ id: 'response.approvalStatus' })}
                    text={data[field]}
                  />
                );
              }
              return (
                <Row
                  key={field}
                  label={formatMessage({ id: `response.${field}` })}
                  text={data[field]}
                />
              );
            })}
          </div>
        </div>
      )}
      {!data && (
        <div className="fail-container">
          <p className="error-message">{formatMessage({ id: 'general.failInfo' })}</p>
          <Button variant="contained" color="primary" onClick={onHomeButtonClick}>
            {formatMessage({ id: 'general.backToStart' })}
          </Button>
        </div>
      )}
      <FooterButtons close={resetState} />
    </div>
  );
}
